// 관리자 좌측 메뉴(LNB) 구성 — 사내 디자인 시스템 SideNav 와 같은 모양: 구역(label + items) · 항목 · 하위 항목 한 단.
// to = 라우트 이름. owns = 메뉴에 없지만 이 항목을 켜야 하는 화면(상세·편집기). visible = 이 구역을 볼 is_admin 조건(기존 sidebar.vue 의 v-if 그대로 — 4 전용은 5(MASTER)에게 안 보인다).
// 아이콘 이름은 packages/shared/components/common/app-icons.js 에 있어야 한다(테스트가 확인).
export const ADMIN_NAV = [
    {
        label: '평가 운영', visible: level => level === 4, items: [
            { label: '평가관리', icon: 'clipboard-list', to: 'ManagingAssessment' },
            { label: '프로젝트 코드', icon: 'folders', to: 'ManagingProjectCode' },
            { label: '평가 그룹', icon: 'stack-2', to: 'ManagingProjectGroup' },
            {
                label: '프로젝트 배정 콘솔', icon: 'route', children: [
                    { label: '배정 콘솔', icon: 'route', to: 'ManagingProjectConsole' },
                    { label: '캠페인 연결 규칙 (고급)', icon: 'link', to: 'ManagingCampaignConnectRule' },
                    { label: '프로젝트 스키마 (고급)', icon: 'schema', to: 'ManagingProjectSchema' },
                ],
            },
            { label: '벤더코드 관리', icon: 'id-badge-2', to: 'ManagingVendorCode' },
            { label: '벤더코드 참여 요청', icon: 'user-plus', to: 'ManagingVendorJoinRequest' },
            { label: '답변 보존 캠페인 재배정', icon: 'arrows-exchange', to: 'CampaignRemap' },
        ],
    },
    {
        label: '사용자', visible: level => level === 4, items: [
            { label: '원청사', icon: 'building', to: 'ManagingClient' },
            { label: '일반기업', icon: 'building-store', to: 'ManagingParticipationCompany', owns: ['CompanyDetail'] },
            { label: '사용자', icon: 'users', to: 'ManagingUser' },
        ],
    },
    {
        label: 'AI 기능', visible: level => level >= 3, items: [
            {
                label: 'AI 보완 검토', icon: 'list-check', children: [
                    { label: '보완 검토', icon: 'list-check', to: 'ManagingSupplementReviewList', owns: ['ManagingSupplementReview'] },
                    { label: '보완 검토 프롬프트', icon: 'message-2', to: 'ManagingSupplementPrompt' },
                ],
            },
            {
                label: 'AI 평가', icon: 'sparkles', children: [
                    { label: '평가 관리', icon: 'sparkles', to: 'ManagingAiAssessment' },
                    { label: '평가 프로파일', icon: 'user-cog', to: 'ManagingEvalProfiles' },
                    { label: 'AI 판단 기준', icon: 'scale', to: 'ManagingEvalPrompt' },
                ],
            },
        ],
    },
    {
        label: '운영 도구', visible: level => level === 4, items: [
            { label: '다운로드 센터', icon: 'download', to: 'DownloadCenter' },
            {
                label: '메일 관리', icon: 'mail', children: [
                    // 스니펫 관리는 내부(개발자용)라 메뉴에 없다 — 라우트(MailSnippet)는 직접 주소로 들어간다
                    { label: '템플릿', icon: 'mail', to: 'MailDashboard', owns: ['MailEditorNew', 'MailEditorEdit', 'MailSnippet'] },
                    { label: '템플릿 시뮬레이션', icon: 'flask', to: 'MailSimulation' },
                    { label: '브랜드(프로젝트)', icon: 'palette', to: 'ProjectBrandManagement' },
                ],
            },
            {
                label: '첨부파일 관리', icon: 'paperclip', children: [
                    { label: '첨부파일 복사', icon: 'files', to: 'CopyAttachments' },
                    { label: '문서 사실 추출', icon: 'file-search', to: 'DocumentFacts' },
                    { label: '추출 배치 관리', icon: 'stack', to: 'DocumentFactBatches' },
                ],
            },
            { label: 'API 이용 현황', icon: 'activity', to: 'ApiObservability' },
        ],
    },
];

export function visibleSections(level, nav = ADMIN_NAV) {
    return nav.filter(s => s.visible(Number(level)));
}

export function isItemActive(item, routeName) {
    if (item.children) return item.children.some(c => isItemActive(c, routeName));
    return item.to === routeName || (item.owns || []).includes(routeName);
}

// 지금 화면이 메뉴의 어디인가 — 상단 바 경로 표시(브레드크럼)와 그룹 펼침에 쓴다.
// 메뉴에 없는 상세 화면(owns)은 소유 항목 뒤에 그 화면 제목을 하나 더 붙인다.
export function activeTrail(routeName, pageTitle, nav = ADMIN_NAV) {
    for (const section of nav) {
        for (const item of section.items) {
            const leaf = item.children ? item.children.find(c => isItemActive(c, routeName)) : (isItemActive(item, routeName) && item);
            if (!leaf) continue;
            const crumbs = [...(item.children ? [item.label] : []), leaf.label];
            if (leaf.to !== routeName && pageTitle) crumbs.push(pageTitle);
            return { section, group: item.children ? item : null, item: leaf, crumbs };
        }
    }
    return { section: null, group: null, item: null, crumbs: pageTitle ? [pageTitle] : [] };
}
